import React from 'react';
import soloStyle from './BackgroundImage.solo.module.scss';
import partnerStyle from './BackgroundImage.partner.module.scss';
import commonStyle from './BackgroundImage.common.module.scss';
import defaultStyle from './BackgroundImage.module.scss';
import { AI_BAS_ADD_ON_IDS, FEELIX_THEMES } from '../../constants';

const getStyle = (theme: string, addonIds?: string[]) => {
  if (theme === FEELIX_THEMES.SOLO) {
    return soloStyle;
  }
  if (theme === FEELIX_THEMES.PARTNER) {
    return partnerStyle;
  }
  if (theme === FEELIX_THEMES.COMMON && addonIds?.some((id) => AI_BAS_ADD_ON_IDS.includes(id))) {
    return commonStyle;
  }

  return defaultStyle;
};

interface BackgroundImageProps {
  theme: string;
  addonIds?: string[];
}

export const BackgroundImage: React.FC<BackgroundImageProps> =
  ({ theme, addonIds }) => {
    const style = getStyle(theme, addonIds);
    return (
      <div
        className={style.backgroundImage}
      />
    );
  };
